<template>
  <div class="uk-grid-medium" uk-grid>
    <div class="uk-width-5-5">
      <div class="d-flex">
        <nav id="breadcrumbs" class="mb-3">
          <ul>
            <li>
              <router-link :to="{ name: 'company.dashboard' }">
                <i class="uil-home-alt"></i>
              </router-link>
            </li>

            <li>
              <router-link :to="{ name: 'company.contents.all' }">{{ this.$t("collectionDetail.contents") }}
              </router-link>
            </li>
            <li>{{ isEditMode ? $t("general.content_edit") : $t("general.add_content") }}</li>
          </ul>
        </nav>
      </div>

      <div class="section-header mb-lg-2 border-0 uk-flex-middle">
        <div class="section-header-left">
          <h2 class="uk-heading-line text-left">
            <span>{{ isEditMode ? $t("general.content_edit") : $t("general.new_content") }} </span>
          </h2>
        </div>
      </div>
      <template v-if="errorMessages">
        <div v-for="(error, index) in errorMessages" :key="index" class="uk-alert-danger" uk-alert>
          <a class="uk-alert-close" uk-close></a>
          <p style="color: red">
            <i class="uil-exclamation-triangle"></i> {{ error }}
          </p>
        </div>
      </template>
      <div v-if="successMessage" class="uk-alert-success" uk-alert>
        <a class="uk-alert-close" uk-close></a>
        <p style="color: green">
          <i class="uil-exclamation-triangle"></i> {{ successMessage }}
        </p>
      </div>

      <div v-show="loading">
        <default-loading></default-loading>
      </div>

      <div v-show="!loading" class="card">
        <!-- SCORM paketi güncellenemez uyarısı (Tüm tablar için geçerli) -->
        <div v-if="isEditMode && is_assigned_content && +form.file_category_id.id === 1" class="alert alert-info mb-0">
          <i class="uil-info-circle mr-2"></i>
          <strong>{{ $t('general.note') }}:</strong> {{ $t('general.content_scorm_info') }}
        </div>

        <ul id="uk-switcher-tab" class="uk-child-width-expand uk-tab stepper-buttons"
            uk-switcher="connect: #course-edit-tab ; animation: uk-animation-slide-left-medium, uk-animation-slide-right-medium">
          <li class="uk-active">
            <a aria-expanded="true" class="p-4" href="#"><i class="icon-feather-flag"></i>
              <b>{{ this.$t("general.home") }}</b></a>
          </li>
          <li class="">
            <a aria-expanded="false" class="p-4" href="#"><i class="uil-book-open"></i>
              <b>{{ this.$t("general.content") }}</b></a>
          </li>
          <li>
            <a aria-expanded="false" class="p-4" href="#"><i class="uil-cog"></i>
              <b>{{ this.$t("general.features") }}</b></a>
          </li>
          <li>
            <a aria-expanded="false" class="p-4" href="#"><i class="uil-invoice"></i>
              <b>{{ this.$t("general.overview") }}</b></a>
          </li>
        </ul>

        <form class="card-body">
          <ul id="course-edit-tab" class="uk-switcher uk-margin" style="touch-action: pan-y pinch-zoom">
            <!--tab: özellikler-->
            <li class="uk-active" style="">
              <div class="row">
                <div class="col-xl-9 m-auto">
                  <div class="form-group row mb-3">
                    <label class="col-md-3 col-form-label" for="course_title">{{
                        this.$t("collectionDetail.content_name")
                      }}<span class="required">*</span></label>
                    <div class="col-md-9">
                      <input id="course_title" v-model="form.title" :placeholder="$t('messages.title')"
                             class="form-control" name="title" required="" type="text" @input="handleTitleChanges"/>
                    </div>
                  </div>

                  <div v-if="isEditMode" class="form-group row mb-3">
                    <label class="col-md-3 col-form-label" for="code">{{ this.$t('general.content_code') }}</label>
                    <div class="col-md-9">
                      <input id="code" :value="item?.code" class="form-control" name="code" placeholder="99999999"
                             readonly type="number"/>
                    </div>
                  </div>

                  <div class="form-group row domain mb-3">
                    <label class="col-md-3 col-form-label" for="duration">{{
                        this.$t("general.duration")
                      }}<span class="required">*</span></label>
                    <div class="col-md-4">
                      <div class="d-flex">
                        <input id="duration" v-model="hour" class="form-control flex-grow-1" placeholder="0" required=""
                               type="number" @keypress="isNumber($event)"/><span>{{
                          $t("general.hour")
                        }}</span>
                      </div>
                    </div>
                    <div class="col-md-5">
                      <div class="d-flex">
                        <input id="duration" v-model="minutes" class="form-control flex-grow-1" max="59" min="1"
                               placeholder="0" required="" type="number" @keypress="isNumber($event)"/><span>{{
                          $t("general.minutes")
                        }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="form-group row mb-3">
                    <label class="col-md-3 col-form-label" for="short_description">{{
                        this.$t("general.description")
                      }}</label>
                    <div class="col-md-9">
                      <textarea id="short_description" v-model="form.description" class="form-control"
                                name="short_description"></textarea>
                    </div>
                  </div>
                  <div class="form-group row mb-3">
                    <label class="col-md-3 col-form-label">
                      {{ $t("general.instructors") }}
                    </label>
                    <div class="col-md-9">
                      <multiselect
                          v-model="form.instructors"
                          :allow-empty="true"
                          :close-on-select="false"
                          :loading="instructorsLoading"
                          :multiple="true"
                          :options="instructorOptions"
                          :searchable="true"
                          :deselect-label="$t('general.remove')"
                          label="name"
                          :placeholder="$t('general.select_instructor')"
                          :select-label="$t('general.select')"
                          :selected-label="$t('general.selected')"
                          track-by="id"
                      >
                        <template #option="{ option }">
                          <div class="content-instructor-option">
                            <img :src="option.photo" :alt="option.name"/>
                            <span>
                              <strong>{{ option.name }}</strong>
                              <small>
                                {{
                                  option.title ||
                                  option.institutionName ||
                                  $t("general.instructor")
                                }}
                              </small>
                            </span>
                          </div>
                        </template>
                        <template #tag="{ option, remove }">
                          <span class="multiselect__tag content-instructor-tag">
                            <span>{{ option.name }}</span>
                            <i
                                aria-hidden="true"
                                class="multiselect__tag-icon"
                                tabindex="1"
                                @click.stop="remove(option)"
                            ></i>
                          </span>
                        </template>
                      </multiselect>
                    </div>
                  </div>
                  <div class="form-group row mb-3">
                    <label class="col-md-3 col-form-label" for="short_description">{{
                        this.$t("faq.category")
                      }}<span class="required">*</span></label>
                    <div class="col-md-9">
                      <multiselect v-model="form.content_category_id" :allow-empty="false"
                                   :options="formattedContentCategories" :placeholder="$t('general.select_a_category')"
                                   :searchable="true" deselectLabel="" label="name" :selectLabel="$t('general.select')"
                                   :selectedLabel="$t('general.selected')"
                                   track-by="id"/>
                    </div>
                  </div>
                  <div class="form-group row mb-3">
                    <label class="col-md-3 col-form-label" for="logo">{{
                        this.$t("collectionDetail.cover_image")
                      }}<span class="required">*</span></label>
                    <div class="col-md-9">
                      <div uk-alert>
                        <a class="uk-alert-close" uk-close></a>
                        <h5><i class="uil-comment-info-alt"></i> {{ $t('general.information') }}</h5>
                        <p v-html="$t('general.catalog_cover_image_info', {
                          formats: '<b>.jpg, .png, .gif</b>',
                          dimensions: '<b>521x288</b>'
                        })"></p>
                      </div>
                      <div class="position-relative d-flex justify-center justify-content-center">
                        <img alt="" class="rounded img-fluid logoarea" src="@/assets/images/no-photo.png"
                             style="height: 190px"/>
                        <input id="logo" accept="image/*" class="d-none" type="file" @change="processFile($event)"/>
                        <button class="btn btn-default btn-icon-label" style="top: 50%; position: absolute"
                                type="button"
                                @click="inputClick()">
                          <span class="btn-inner--icon">
                            <i class="uil-image"></i>
                          </span>
                          <span class="btn-inner--text">{{
                              $t("general.image_change")
                            }}</span>
                        </button>
                      </div>
                      <ai-cover-image-generator
                          :max-size-mb="10"
                          file-prefix="ai-content-cover"
                          @image-selected="handleAiCoverImageSelected"
                      />
                    </div>
                  </div>

                  <!--               Kazanılacak yetkinlikler-->
                  <div class="form-group">
                    <label class="typo__label"> {{ $t('general.competencies_to_be_acquired') }} <span
                        class="required mt-2"></span></label>
                    <CompetenciesInputSelection v-model="form.selectedCompetencies"/>
                  </div>

                  <div class="form-group">
                    <label class="typo__label">{{
                        this.$t("general.category_tags")
                      }}<span class="required mt-2"></span>
                      <i aria-expanded="false" class="uil-info-circle ml-1"
                         :uk-tooltip="'title: ' + $t('general.alphanumeric_dashes_underscores_only') + '; pos: right'"></i></label>
                    <multiselect v-model="hashtags" :multiple="true" :openDirection="'bottom'"
                                 :options="hashtags_options"
                                 :placeholder="$t('general.search_in_menu')"
                                 :tag-placeholder="$t('general.search_in_menu')"
                                 :taggable="true" :deselectGroupLabel="$t('general.please_enter_to_deselect_group')"
                                 :deselectLabel="$t('general.please_enter_to_remove')" label="name"
                                 :selectGroupLabel="$t('general.please_enter_to_select_group')"
                                 :selectLabel="$t('general.press_enter_to_select')"
                                 :selectedLabel="$t('general.selected')" track-by="id" @change="(val) => {
                        hashtags = val;
                      }
                        " @close="isClosedHashtagSelector = true" @open="isClosedHashtagSelector = false"
                                 @tag="addTag">

                      <template slot="noOptions"><span>{{ $t('general.no_options') }}</span></template>
                    </multiselect>
                    <span v-show="isEmptyHashtags()" class="typo__label form__label text-warning mt-1 ml-1">{{ $t('general.select_at_least_one_value') }}</span>
                  </div>

                </div>
              </div>
              <div class="uk-card-footer float-right pb-0 pr-0">
                <button class="uk-button uk-button-primary small" type="button" @click="validateAndSwitch(1)">
                  <i class="icon-feather-arrow-right"></i>
                  {{ this.$t("general.save_and_continue") }}
                </button>
              </div>
            </li>
            <!--tab: icerik olustur-->
            <li class="" style="">
              <div class="row">
                <div class="col-md-12">
                  <!-- Atanmış içerik uyarısı -->
                  <div v-if="isEditMode && is_assigned_content" class="alert alert-warning mb-3">
                    <i class="uil-info-circle mr-2"></i>
                    <strong>{{ $t('general.caution') }} :</strong> {{ $t('general.assignment_score_cant_change') }}
                  </div>

                  <div v-if="form.file_category_id && +form.file_category_id.id === 1
                    " class="form-group row mb-3">
                    <label class="col-md-4 col-form-label" for="use_content_point">
                      {{ $t('general.use_scorm_score') }}
                    </label>
                    <div class="col-md-8">
                      <label class="uk-switch" for="use_content_point">
                        <input id="use_content_point" v-model="form.use_content_point" type="checkbox"/>
                        <div class="uk-switch-slider"></div>
                      </label>
                    </div>
                  </div>

                  <div v-if="!form.use_content_point" class="form-group row mb-3">
                    <label class="col-md-4 col-form-label" for="score">{{
                        this.$t("general.content_score")
                      }}<span class="required">*</span>
                    </label>
                    <div class="col-md-8">
                      <input id="score" v-model="form.point" :disabled="is_assigned_content" class="form-control"
                             max="100" min="1" placeholder="100"
                             required="" type="number" @keypress="isNumber($event)"/>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group row mb-2 input-checkbox">
                    <div class="col-md-4">
                      <label class="col-form-label mb-1" for="pass">{{
                          this.$t("general.content_type")
                        }}<span class="required">*</span>
                      </label>
                    </div>

                    <div class="col-md-8">
                      <multiselect v-model="form.file_category_id" :allow-empty="false" :disabled="is_assigned_content"
                                   :options="formattedFileTypes"
                                   :placeholder="$t('collectionDetail.content_type_placeholder')"
                                   :searchable="true"
                                   deselectLabel=""
                                   :customLabel="(option) => $t(option.key)" :selectLabel="$t('general.select')" track-by="id"
                                   @input="changeOption"/>
                    </div>
                  </div>
                </div>
                <div v-if="form.file_category_id" class="col-md-12">
                  <h4 class="text-center mt-4">
                    {{ $t(selected_content_type.key) }} {{ $t('general.upload') }}
                    <span class="required">*</span>
                  </h4>

                  <!-- Dosya boyut uyarısı -->
                  <div v-if="!isEditMode && $t(selected_content_type.name).toLowerCase().includes('doküman')" class="alert alert-warning mb-3">
                    <i class="uil-info-circle mr-2"></i>
                      {{ $t('general.document_size_warning') }}
                  </div>
                  
                  <!-- aktif değil -->
                  <div v-if="!isEditMode && selected_content_type.key === 'documents.scorm_package'" class="alert alert-warning mb-3">
                    <i class="uil-info-circle mr-2"></i>
                    {{ $t('general.document_size_warning') }}
                  </div>

                  <div v-if="fileSizeError" class="alert alert-danger mb-3">
                    <i class="uil-exclamation-triangle mr-2"></i>
                    {{ fileSizeError }}
                  </div>

                  <div v-if="selected_content_type.accept === 'id'">
                    <div class="form-group">
                      <input v-model="form.url" class="form-control" min="0" :placeholder="$t('general.id')" type="number"/>
                    </div>
                  </div>

                  <!-- URL Input  (Jitsi, URL, Video URL) -->
                  <document-url-input
                      v-else-if="['documents.jitsi', 'documents.url', 'documents.video_url'].includes(selected_content_type.key)"
                      v-model="form.url"
                  />

                  <!-- Classroom Education  -->
                  <document-classroom-education
                      v-else-if="selected_content_type.key === 'documents.classroom_education'"
                      v-model="form.classroom_education"
                      :education-places="educationPlaces"
                      :instructor-names="instructorNames"
                      @add-instructor-name="addInstructorName"
                      @add-education-place="addEducationPlace"
                  />
                  <!-- Check List -->
                  <document-check-list-item
                      v-else-if="selected_content_type.key === 'documents.check_list_item'"
                      :description.sync="form.content_check_list_item_description"
                      :items.sync="form.content_check_list_items"
                      @add-item="addCheckListItem"
                      @remove-item="removeCheckListItem"
                  />
                  <!-- Mission Component (Görev şuan aktif değil)-->
                  <document-mission
                      v-else-if="selected_content_type.key === 'documents.mission'"
                      :acceptable-file-type="acceptable_file_type"
                      :accepted-right-answer.sync="form.mission.accepted_right_answer"
                      :answer-type.sync="form.mission.answer_type"
                      :completion-rule.sync="form.mission.completion_rule"
                      :icon="selected_content_type.icon"
                      :mission-description.sync="form.mission.mission_description"
                      :mission-file="form.mission.mission_file"
                      :should-upload-mission-file.sync="form.mission.should_upload_mission_file"
                      @file-uploaded="handleMissionFileUpload"
                  />
                  <!-- Webinar  -->
                  <document-webinar
                      v-else-if="selected_content_type.key === 'documents.webinar'"
                      :integration-id.sync="form.webinar.integration_id"
                      :integration-type.sync="webinar_integrationType"
                      :is-auto-recording-enabled.sync="form.webinar.is_auto_recording_enabled"
                      :password.sync="form.webinar.password"
                      :starts-at.sync="form.webinar.starts_at"
                      :webinar-types="webinar_types"
                      :instructor-name.sync="form.webinar.webinar_instructor_name"
                  />

                  <!-- Information Content (bilgi içeriği) -->
                  <document-information-content
                      v-else-if="selected_content_type.key === 'documents.information_content'"
                      v-model="form.information_content"
                  />

                  <!-- Video+interactive video -->
                  <document-video-document
                      v-else-if="selected_content_type.key === 'documents.video_document'"
                      :acceptable-file-type="acceptable_file_type"
                      :can-be-fast-forwarded-when-completed.sync="video_is_completed_it_can_be_fast_forwarded"
                      :can-be-fast-forwarded.sync="video_can_be_fast_forwarded"
                      :existing-file="item?.file?.file_link"
                      :icon="selected_content_type.icon"
                      :is-interactive-video-active.sync="isInteractiveVideoActive"
                      :video-doc-info="videoDocInfo"
                      :video-url="interactiveVideoURL"
                      @file-uploaded="handleVideoFileUpload"
                      @upload-error="handleUploadError"
                  />

                  <!-- PowerPoint-->
                  <document-powerpoint-document
                      v-else-if="selected_content_type.key === 'documents.powerpoint_document'"
                      :acceptable-file-type="acceptable_file_type"
                      :completion-timeout.sync="form.powerpoint.completion_timeout"
                      :content-type-key="selected_content_type.key"
                      :existing-file="item?.file"
                      :file-category-id="form.file_category_id?.id"
                      :icon="selected_content_type.icon"
                      :is-completion-timeout.sync="form.powerpoint.is_completion_timeout"
                      :is-edit-mode="isEditMode"
                      :is-powerpoint-scorm-file.sync="form.powerpoint.is_scorm_file"
                      @file-uploaded="handleGeneralFileUpload"
                  />

                  <!-- General File Upload Component (for standard document types) -->
                  <!-- scorm-visual_document-pdf-word-audio-->
                  <document-file-upload
                      v-else-if="usesGeneralFileUpload"
                      :acceptable-file-type="acceptable_file_type"
                      :content-type-key="selected_content_type.key"
                      :existing-file="item?.file"
                      :file-category-id="form.file_category_id?.id"
                      :icon="selected_content_type.icon"
                      :is-edit-mode="isEditMode"
                      @file-uploaded="handleGeneralFileUpload"
                  />

                  <!-- diğer dosyalar -->
                  <div v-else class="uploadOuter">
                    <label class="btn btn-info" for="uploadFile"><i class="uil-upload"></i>
                      {{ $t("general.upload") }}</label>
                    <strong>{{ $t("general.or") }}</strong>
                    <span class="dragBox">
                      <i :class="selected_content_type.icon"></i>
                      {{ $t(selected_content_type.key + "_drag_drop") }}
                      <input id="uploadFile" :accept="acceptable_file_type" draggable="true" type="file"
                             @change="dropped"
                             @dragenter="drag" @dragleave="drop" @dragover.prevent/>
                    </span>
                  </div>

                </div>
              </div>
              <div class="uk-card-footer float-right pb-0 pr-0">
                <button class="uk-button uk-button-outline mr-2" type="button" @click="switcherChange(0)">
                  <i class="icon-feather-arrow-left"></i>{{ this.$t("general.previous") }}
                </button>
                <button class="uk-button uk-button-primary small" type="button" @click="validateAndSwitch(2)">
                  <i class="icon-feather-arrow-right"></i>
                  {{ this.$t("general.save_and_continue") }}
                </button>
              </div>
            </li>

            <!--tab: ayarlar :NOTE :content_share ve experience_share verileri api'den istendiği için bu yorum alanalrı silinmedi,  -->
            <li>
              <div class="container">
                <div class="row">
                  <div class="col-md-12">
                    <!-- <div class="form-group row mb-2">
                      <label
                        class="col-md-4 col-form-label"
                        for="website_keywords"
                        >İçerik Paylaşımı
                        <i
                          class="uil-info-circle"
                          uk-tooltip="title: lorem ipsum dolor sit amet"
                          title=""
                          aria-expanded="false"
                        ></i
                      ></label>
                      <div class="col-md-8">
                        <label class="uk-switch" for="content_share">
                          <input type="checkbox" id="content_share" v-model="form.share_content" @change="handleContentShareChanges" />
                          <div class="uk-switch-slider"></div>
                        </label>
                      </div>
                    </div> -->
                    <!-- <div class="form-group row mb-2">
                      <label
                        class="col-md-4 col-form-label"
                        for="website_keywords"
                        >{{this.$t('general.experience_sharing')}}
                        <i
                          class="uil-info-circle"
                          uk-tooltip="title: lorem ipsum dolor sit amet"
                          title=""
                          aria-expanded="false"
                        ></i
                      ></label>
                      <div class="col-md-8">
                        <label class="uk-switch" for="experience_share">
                          <input type="checkbox" id="experience_share" v-model="form.share_experience" />
                          <div class="uk-switch-slider"></div>
                        </label>
                      </div>
                    </div> -->
                    <div class="form-group row mb-2">
                      <label class="col-md-4 col-form-label" for="website_keywords">{{
                          this.$t("general.certificate_selection")
                        }}
                        <i class="uil-info-circle"
                           :uk-tooltip="'title: ' + $t('general.certificate-info')"></i></label>
                      <div class="col-md-8">
                        <multiselect v-model="form.certificate_id" :allow-empty="true" :options="certificate_items"
                                     :placeholder="$t('general.select_certificate')" :searchable="true" deselectLabel=""
                                     label="name"
                                     :selectLabel="$t('general.select')" :tag-placeholder="$t('general.select_certificate')" track-by="id"/>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="uk-card-footer float-right pb-0 pr-0">
                  <button class="uk-button uk-button-outline mr-2" type="button" @click="switcherChange(1)">
                    <i class="icon-feather-arrow-left"></i>{{ this.$t("general.previous") }}
                  </button>
                  <button class="uk-button uk-button-primary small" type="button" @click="validateAndSwitch(3)">
                    <i class="icon-feather-arrow-right"></i>
                    {{ this.$t("general.save_and_continue") }}
                  </button>
                </div>
              </div>
            </li>
            <li>
              <div class="row">
                <div class="col-12 my-lg-5">
                  <div class="text-center">
                    <h2 class="mt-0">
                      <i class="icon-feather-check-circle text-success"></i>
                    </h2>
                    <h3 class="mt-0">
                      {{ this.$t("general.content_is_ready") }}
                    </h3>

                    <div class="col-md-6 offset-md-3">
                      <table class="uk-table uk-table-divider result-table">
                        <tbody>
                        <tr>
                          <td class="text-center" colspan="2">
                            <img alt="" class="logoarea rounded img-fluid" src="@/assets/images/no-photo.png"/>
                          </td>
                        </tr>
                        <tr>
                          <td class="text-right">
                            {{ this.$t("collectionDetail.content_name") }}
                          </td>
                          <td class="text-left">
                            <b>{{ title }}</b>
                          </td>
                        </tr>
                        <tr>
                          <td class="text-right">
                            {{ this.$t("collectionDetail.content_type") }}
                          </td>
                          <td class="text-left">
                            <b>{{ file_type_selected }}</b>
                          </td>
                        </tr>
                        <tr>
                          <td class="text-right">
                            {{ this.$t("general.category_tags") }}
                          </td>
                          <td class="text-left">
                            <b>{{ hashtags_result }}</b>
                          </td>
                        </tr>
                        <tr>
                          <td class="text-right">
                            {{ $t("general.instructors") }}
                          </td>
                          <td class="text-left">
                            <b>{{ selectedInstructorNames }}</b>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <div class="uk-card-footer float-right pb-0 pr-0">
                <button class="uk-button uk-button-outline mr-2" type="button" @click="switcherChange(2)">
                  <i class="icon-feather-arrow-left"></i>{{ this.$t("general.previous") }}
                </button>
                <button class="uk-button uk-button-primary small" type="button" @click="saveForm()">
                  <i class="icon-feather-arrow-right"></i>
                  {{ isEditMode ? $t("general.save") : $t("general.save_and_continue") }}
                </button>
                <button v-if="!isEditMode" :disabled="!$hasPermission('create_assignment')" :style="{
                    cursor: !$hasPermission('create_assignment') ? 'not-allowed' : 'pointer'
                  }"
                        :uk-tooltip="!$hasPermission('create_assignment') ? $t('general.no_permission') : ''"
                        class="uk-button uk-button-primary small ml-2" type="button" @click="saveForm('assign_page')">
                  <i class="uil-location-arrow"></i>
                  {{ $t("general.save_and_assign") }}
                </button>
              </div>
            </li>
          </ul>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/core/services";
import {
  AnswerTypeSelector,
  DocumentUrlInput,
  DocumentClassroomEducation,
  DocumentCheckListItem,
  DocumentMission,
  DocumentWebinar,
  DocumentInformationContent,
  DocumentVideoDocument,
  DocumentPowerpointDocument,
  DocumentFileUpload
} from "@/view/company/Content/components";
import Multiselect from "vue-multiselect";
import axios from "axios";
import module, {
  CONTENT_CATEGORIES,
  CONTENT_CATEGORIES_URL,
  FILE_TYPES,
  FILE_TYPES_URL,
  GET_CONTENT_CATEGORIES,
  GET_FILE_TYPES,
  MODULE_NAME,
} from "@/core/services/store/content_categories.module";
import contentModule, {
  BASE_URL,
  CREATE_ITEM,
  UPDATE_CONTENT_ITEM,
  GET_ITEM,
  ITEM,
  ERROR,
  LOADING,
  MODULE_NAME as CONTENT_MODULE_NAME,
} from "@/core/services/store/content.module";

import certificate_module, {
  BASE_URL as CERTIFICATE_BASE_URL,
  GET_ITEMS as CERTIFICATE_GET_ITEMS,
  ITEMS as CERTIFICATE_ITEMS,
  MODULE_NAME as CERTIFICATE_MODULE_NAME,
} from "@/core/services/store/certificate.module";

import DefaultLoading from "@/view/components/loading/DefaultLoading";
import { VueEditor } from "vue2-editor";
import ToggleSwitch from "@/view/components/toggle/toggle-switch/toggle-switch.vue";
import interactiveVideoPlayerWrapper from "@/view/components/video/interactive-video/InteractiveVideoPlayerWrapper.vue";
import VideoPlayer from "@/view/components/video/VideoPlayer.vue";
import VideoTypeSelector from "@/view/components/video/VideoTypeSelector.vue";
import CompetenciesInputSelection from "@/view/components/input/CompetenciesInputSelection.vue";
import { showError } from "@/utils/alertUtils";
import AiCoverImageGenerator from "@/view/components/ai-cover-image/AiCoverImageGenerator.vue";
import instructorService, {
  normalizeInstructor,
} from "@/core/services/instructor.service";

const _CERTIFICATE_MODULE = CERTIFICATE_MODULE_NAME;

export default {
  name: "ContentAddUpdate",
  components: {
    CompetenciesInputSelection,
    VideoPlayer,
    ToggleSwitch,
    AnswerTypeSelector,
    Multiselect,
    DefaultLoading,
    VueEditor,
    interactiveVideoPlayerWrapper,
    VideoTypeSelector,
    DocumentUrlInput,
    DocumentClassroomEducation,
    DocumentCheckListItem,
    DocumentMission,
    DocumentWebinar,
    DocumentInformationContent,
    DocumentVideoDocument,
    DocumentPowerpointDocument,
    DocumentFileUpload,
    AiCoverImageGenerator
  },
  data() {
    return {
      hashtags: [],
      isClosedHashtagSelector: false,
      hashtags_options: [],
      title: this.$t("general.heading"),
      hashtags_result: this.$t("general.select_category_tags"),
      content_share: "Kapalı",
      file_type_selected: this.$t("general.select_content_type"),
      successMessage: "",
      errorMessages: [],
      fileSizeError: "",
      fileSizeErrorSize: null,
      instructorNames: [],
      instructorOptions: [],
      instructorsLoading: false,
      educationPlaces: [],
      selectedWebinarType: null,
      hour: "",
      minutes: "",
      form: {
        title: "",
        duration: "",
        point: 100,
        description: "",
        instructors: [],
        content_category_id: null,
        file_category_id: null,
        share_content: 0,
        share_experience: 0,
        hashtags: [],
        cover_photo: null,
        files: [],
        url: null,
        use_content_point: false,
        certificate_id: null,
        classroom_education: {
          instructor_name: "",
          accommodation_cost: "",
          education_place: "",
          education_cost: "",
          transportation_cost: "",
          education_place_cost: "",
          capacity: ""
        },
        content_check_list_items: [],
        content_check_list_item_description: "",
        information_content: "",
        mission: {
          mission_description: "",
          answer_type: "file",
          completion_rule: "answered",
          mission_file: "",
          should_upload_mission_file: false,
          accepted_right_answer: ""
        },
        webinar: {
          starts_at: null,
          password: null,
          is_auto_recording_enabled: false,
          integration_id: null,
          timezone: "Europe/Istanbul",
          webinar_instructor_name: null
        },
        powerpoint: {
          is_scorm_file: false,
          is_completion_timeout: false,
          completion_timeout: 1
        },
        selectedCompetencies: [],
      },
      acceptable_file_type: "*",
      selected_content_type: [],
      webinar_types: [],
      webinar_integrationType: null,
      video_can_be_fast_forwarded: false,
      video_is_completed_it_can_be_fast_forwarded: false,
      isInteractiveVideoActive: false,
      interactiveVideoURL: "",
      videoDocInfo: "",
      is_assigned_content: false,
    };
  },
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }

    registerStoreModule(MODULE_NAME, module);
    registerStoreModule(_CERTIFICATE_MODULE, certificate_module);
    registerStoreModule(CONTENT_MODULE_NAME, contentModule);
  },
  computed: {
    isEditMode() {
      return !!this.$route.params.id;
    },
    loading() {
      return store.getters[CONTENT_MODULE_NAME + "/" + LOADING];
    },
    certificate_items() {
      return store.getters[CERTIFICATE_MODULE_NAME + "/" + CERTIFICATE_ITEMS];
    },
    formattedFileTypes() {
      let results = [];
      if (this.file_types === null) return [];
      for (let i = 0; i < this.file_types.length; i++) {
        let currentItem = this.file_types[i];
        if (currentItem) {
          results.push({
            icon: currentItem.icon,
            name: currentItem.name,
            key: currentItem.key_name,
            accept: currentItem.accept,
            id: currentItem.id,
          });
        }
      }
      return results;
    },
    formattedContentCategories() {
      let results = [];
      if (this.content_categories === null) return [];
      for (let i = 0; i < this.content_categories.length; i++) {
        let currentItem = this.content_categories[i];
        if (currentItem) {
          results.push({
            icon: currentItem.icon,
            name: currentItem.name,
            id: currentItem.id,
          });
        }
      }
      return results;
    },
    file_types() {
      return store.getters[MODULE_NAME + "/" + FILE_TYPES];
    },
    content_categories() {
      return store.getters[MODULE_NAME + "/" + CONTENT_CATEGORIES];
    },
    error() {
      return store.getters[CONTENT_MODULE_NAME + "/" + ERROR];
    },
    item() {
      return store.getters[CONTENT_MODULE_NAME + "/" + ITEM];
    },
    selectedInstructorNames() {
      if (!this.form.instructors.length) {
        return this.$t("general.instructor_not_selected");
      }
      return this.form.instructors
          .map((instructor) => instructor.name)
          .join(", ");
    },
    interactiveQuestion() {
      return this.$store.getters.markers;
    },
    usesGeneralFileUpload() {
      const standardTypes = [
        'documents.scorm_package',
        'documents.visual_document',
        'documents.pdf_document',
        'documents.word_document',
        'documents.audio_document'
      ];
      return standardTypes.includes(this.selected_content_type.key);
    },
  },
  methods: {
    changeWebinar(event) {
      this.selectedWebinarType = event;
      this.form.webinar.integration_id = event.id
    },
    removeCheckListItem(index) {
      this.form.content_check_list_items.splice(index, 1);
    },
    isNumber(evt) {
      evt = evt ? evt : window.event;
      const charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    setHashtags() {
      axios
          .get(`/api/content-hashtags`, {
            headers: this.apiHeaders,
          })
          .then((response) => {
            this.hashtags_options = response.data;
          });
    },
    getCertificates() {
      this.$store.dispatch(
          CERTIFICATE_MODULE_NAME + "/" + CERTIFICATE_GET_ITEMS,
          {
            url: CERTIFICATE_BASE_URL,
            filters: {
              status_id: 1,
              order: "asc",
              sort: "id",
            },
          }
      );
    },
    async getInstructorOptions() {
      this.instructorsLoading = true;
      try {
        this.instructorOptions =
            await instructorService.listActiveInstructorOptions();
      } catch (error) {
        const message =
            error?.response?.data?.message ||
            error?.message ||
            this.$t("general.instructor_list_load_failed");
        showError(message);
      } finally {
        this.instructorsLoading = false;
      }
    },
    isEmptyHashtags() {
      return this.isClosedHashtagSelector && this.hashtags.length === 0;
    },
    handleHashtagsSelected() {
      let data = JSON.parse(JSON.stringify(this.hashtags));
      if (data.length > 0)
        this.hashtags_result = data
            .map(function (elem) {
              return elem.name;
            })
            .join(", ");
      else this.hashtags_result = this.$t("general.select_category_tags");
      this.form.hashtags = data.map(function (elem) {
        return elem.name;
      });
    },
    changeOption() {
      let id = this.form.file_category_id.id;
      if (id) {
        let ContentType = this.getContentTypeById(id);
        this.file_type_selected = ContentType.name;
        this.acceptable_file_type = ContentType.accept;
        this.selected_content_type = ContentType;
        if (this.selected_content_type.key === 'documents.classroom_education') {
          axios
              .get(`/api/content-classroom-education-hashtags`, {
                headers: this.apiHeaders,
              })
              .then((response) => {
                this.instructorNames = response.data.instructor_name;
                this.educationPlaces = response.data.education_place;
              });
        } else if (this.selected_content_type.key === 'documents.webinar') {
          axios
              .get(`/api/webinar-integrations`, {
                headers: this.apiHeaders,
              })
              .then((response) => {
                response.data.forEach((data) => {
                  this.webinar_types.push({ name: data.integration.name, id: data.id, key: data.integration.key_name })
                })
              });
        }
        this.form.files = [];
        this.form.url = null;
        this.interactiveVideoURL = "";
        this.fileSizeError = "";
        this.fileSizeErrorSize = null;
        $("#preview").html("");
        $("#previewMission").html("");
        $("#uploadFile").val("");
      }
    },
    getFileSizeLimitInBytes() {
      const megabyte = 1024 * 1024;
      const isPowerpointScorm =
          this.selected_content_type.key === "documents.powerpoint_document" &&
          this.form.powerpoint.is_scorm_file;

      return (isPowerpointScorm ? 95 : 300) * megabyte;
    },
    getReadableFileSizeLimit() {
      return `${Math.round(this.getFileSizeLimitInBytes() / (1024 * 1024))} MB`;
    },
    buildFileSizeErrorMessage(file) {
      const fileSize = file?.size ?? this.fileSizeErrorSize;
      if (!fileSize) return "";

      return this.$t("general.file_size_limit_exceeded")
          .replace(":currentSize", this.bytesToSize(fileSize))
          .replace(":maxSize", this.getReadableFileSizeLimit());
    },
    validateFileSize(file) {
      if (!(file instanceof File)) return true;

      if (file.size <= this.getFileSizeLimitInBytes()) {
        this.fileSizeError = "";
        this.fileSizeErrorSize = null;
        return true;
      }

      this.fileSizeErrorSize = file.size;
      const message = this.buildFileSizeErrorMessage(file);
      this.fileSizeError = message;
      this.scrollToTop();

      return false;
    },
    getContentTypeById(id) {
      let data;
      this.formattedFileTypes.forEach((item) => {
        if (item.id === id) {
          data = item;
        }
      });
      return data;
    },
    saveForm(process_type) {
      let form = this.form;
      if (!this.isValidFields("ALL")) return false;
      if (form.files instanceof File && !this.validateFileSize(form.files)) return false;
      if (
          this.selected_content_type.key === "documents.mission" &&
          form.mission.mission_file instanceof File &&
          !this.validateFileSize(form.mission.mission_file)
      ) return false;

      if (this.acceptable_file_type === "url") {
        if (!form.url.includes("http")) form.url = "https://" + form.url;
      }

      let formData = new FormData();
      if (this.selected_content_type.key === "documents.mission") {
        formData.append("mission_description", form.mission.mission_description);
        formData.append("answer_type", form.mission.answer_type);
        formData.append("completion_rule", form.mission.completion_rule);

        // Mission file sadece File instance ise gönder (yeni yüklendiyse), URL string ise gönderme
        if (form.mission.mission_file && form.mission.mission_file instanceof File) {
          formData.append("mission_file", form.mission.mission_file);
        }

        formData.append("should_upload_mission_file", form.mission.should_upload_mission_file);
        formData.append("accepted_right_answer", form.mission.accepted_right_answer);
      }
      if (this.selected_content_type.key === "documents.webinar") {
        formData.append("webinar_starts_at", new Date(form.webinar.starts_at).toISOString().replace(/.\d+Z$/g, "Z"));
        formData.append("webinar_password", form.webinar.password);
        formData.append("webinar_is_auto_recording_enabled", form.webinar.is_auto_recording_enabled);
        formData.append("webinar_timezone", form.webinar.timezone);
        formData.append("webinar_integration_id", form.webinar.integration_id);
        if (form.webinar.webinar_instructor_name) {
          formData.append("webinar_instructor_name", form.webinar.webinar_instructor_name);
        }
      }
      if (this.selected_content_type.key === "documents.powerpoint_document") {
        formData.append("is_powerpoint_scorm_file", form.powerpoint.is_scorm_file);
        // Scorm ise completion_timeout gönderilmez, sadece scorm olmayan süreli pptx'lerde gönderilir
        if (!form.powerpoint.is_scorm_file && form.powerpoint.is_completion_timeout) {
          formData.append("completion_timeout", Number(form.powerpoint.completion_timeout));
        } else {
          formData.append("completion_timeout", null);
        }
      }
      this.video_is_completed_it_can_be_fast_forwarded ? formData.append("video_is_completed_it_can_be_fast_forwarded", true) : null;
      this.video_can_be_fast_forwarded ? formData.append("video_can_be_fast_forwarded", true) : null;

      formData.append("title", form.title);
      formData.append("point", form.point);
      formData.append("duration", form.duration);
      formData.append("has_url", this.acceptable_file_type === "url" ? 1 : 0);
      formData.append(
          "has_anzera_id",
          this.acceptable_file_type === "id" ? 1 : 0
      );
      formData.append("url", form.url);
      formData.append("description", form.description);
      const instructorIds = form.instructors
          .map((instructor) => Number(instructor.id))
          .filter((id) => Number.isFinite(id));
      if (instructorIds.length) {
        instructorIds.forEach((id) => {
          formData.append("instructor_ids[]", id);
        });
      } else if (this.isEditMode) {
        formData.append("instructor_ids", "null");
      }
      formData.append("content_category_id", form.content_category_id.id);
      formData.append("file_category_id", form.file_category_id.id);
      formData.append(
          "use_content_point",
          form.use_content_point === true || form.use_content_point === 1 ? 1 : 0
      );
      // Classroom education data
      formData.append("instructor_name", form.classroom_education.instructor_name || "");
      formData.append("accommodation_cost", form.classroom_education.accommodation_cost || "");
      formData.append("education_place", form.classroom_education.education_place || "");
      formData.append("education_cost", form.classroom_education.education_cost || "");
      formData.append("transportation_cost", form.classroom_education.transportation_cost || "");
      formData.append("education_place_cost", form.classroom_education.education_place_cost || "");
      formData.append("capacity", form.classroom_education.capacity || "");
      this.form.content_check_list_items.forEach((element, index) => {
        formData.append(
            "content_check_list_items[" + index + "][name]",
            element.name
        );

        formData.append(
            "content_check_list_items[" + index + "][is_mandatory]",
            element.is_mandatory === true ? 1 : 0
        );
      });
      formData.append(
          "content_check_list_item_description",
          form.content_check_list_item_description
      );
      if (form.use_content_point) {
        formData.append("point", 0);
      } else {
        formData.append("point", form.point);
      }
      form.hashtags.forEach((item) => formData.append("hashtags[]", item));
      form.selectedCompetencies.forEach((item) => formData.append("competencies[]", item.id));

      // Cover photo sadece File instance ise gönder (yeni yüklendiyse veya değiştirildiyse)
      if (form.cover_photo && form.cover_photo instanceof File) {
        formData.append("cover_photo", form.cover_photo);
      }

      form.information_content
          ? formData.append("information_content", form.information_content)
          : null;

      if (form.files) formData.append("file", form.files);

      if (form.certificate_id)
        formData.append("certificate_id", form.certificate_id.id);

      // Share content ve share experience alanları (backend için zorunlu) -not:html k
      formData.append(
          "share_content",
          form.share_content === true || form.share_content === 1 ? 1 : 0
      );
      formData.append(
          "share_experience",
          form.share_experience === true || form.share_experience === 1 ? 1 : 0
      );

      /* interactive video soruları aktif ise bu alan çalışacak */
      formData.append("is_video_interaction", this.isInteractiveVideoActive ? 1 : 0)

      if (this.isInteractiveVideoActive && Array.isArray(this.interactiveQuestion)) {
        const interactiveQuestion = this.interactiveQuestion;

        // Edit modunda exam.id gönder
        if (this.isEditMode) {
          // İlk marker'dan exam_id'yi al, yoksa item.exam_id'yi kullan
          const examId = interactiveQuestion.length > 0 && interactiveQuestion[0].exam_id
              ? interactiveQuestion[0].exam_id
              : this.item?.exam_id;

          if (examId) {
            formData.append('exam[id]', examId);
          }
        }

        this.interactiveQuestion.forEach((q, qIdx) => {
          // Edit modunda: Yeni eklenen sorular için ID null, mevcut sorular için gerçek ID
          if (this.isEditMode) {
            if (q.isNew) {
              formData.append(`exam[questions][${qIdx}][id]`, null);
            } else if (q.id) {
              formData.append(`exam[questions][${qIdx}][id]`, q.id);
            }
          }

          formData.append(`exam[questions][${qIdx}][text]`, q.text || '');
          formData.append(`exam[questions][${qIdx}][type]`, q.type || '');
          formData.append(`exam[questions][${qIdx}][time_in_video]`, q.time_in_video || '');
          formData.append(`exam[questions][${qIdx}][back_time]`, q.back_time || '');
          formData.append(`exam[questions][${qIdx}][correct_feedback]`, q.correct_feedback || '');
          formData.append(`exam[questions][${qIdx}][incorrect_feedback]`, q.incorrect_feedback || '');
          if (Array.isArray(q.options)) {
            q.options.forEach((opt, oIdx) => {
              // Edit modunda: Yeni eklenen seçenekler için ID null, mevcut seçenekler için gerçek ID
              if (this.isEditMode) {
                if (q.isNew || !opt.id) {
                  formData.append(`exam[questions][${qIdx}][options][${oIdx}][id]`, null);
                } else {
                  formData.append(`exam[questions][${qIdx}][options][${oIdx}][id]`, opt.id);
                }
              }

              formData.append(`exam[questions][${qIdx}][options][${oIdx}][name]`, opt.name || '');
              formData.append(`exam[questions][${qIdx}][options][${oIdx}][is_correct]`, opt.is_correct ? 1 : 0);
            });
          }
        });
      }

      const action = this.isEditMode ? UPDATE_CONTENT_ITEM : CREATE_ITEM;
      const url = this.isEditMode ? `${BASE_URL}/${this.$route.params.id}/update` : BASE_URL;

      store
          .dispatch(CONTENT_MODULE_NAME + "/" + action, {
            url: url,
            contents: formData,
          })
          .then((response) => {
            $("html, body").animate({ scrollTop: 0 }, "slow");
            if (!this.error) {
              this.successMessage = this.isEditMode
                  ? this.$t("general.successfully_updated")
                  : this.$t("general.successfully_created");

              if (process_type === "assign_page") {
                this.$router.push({
                  name: "company.assignments.add",
                  params: {
                    id: response.id,
                    title: response.title,
                    name: response.name ?? response.file_category?.key_name,
                  },
                });
              } else {
                this.$router.push({ name: "company.contents.all" });
              }
            } else this.errorMessages.push(this.error);
          })
          .catch((error) => {
            $("html, body").animate({ scrollTop: 0 }, "slow");

            const errorMessage = error?.response?.status === 413
                ? this.buildFileSizeErrorMessage(form.files)
                : error?.response?.data?.message || error?.message || this.$t("general.error_occurred");
            this.fileSizeError = error?.response?.status === 413 ? errorMessage : this.fileSizeError;
            if (error?.response?.status !== 413) {
              showError(errorMessage);
            }

          });
    },
    validateURL(url) {
      var res = url.match(
          /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
      );
      return res !== null;
    },
    handleTitleChanges(e) {
      this.title = e.target.value;
    },
    handleContentShareChanges(e) {
      // Share content değişikliklerini izle (şu an sadece yorum satırında kullanılıyor)
      if (e.target.checked) {
        this.content_share = "Açık";
      } else {
        this.content_share = "Kapalı";
      }
    },
    getContentCategories() {
      this.$store.dispatch(MODULE_NAME + "/" + GET_CONTENT_CATEGORIES, {
        url: CONTENT_CATEGORIES_URL,
      });
    },
    getFileCategories() {
      this.$store.dispatch(MODULE_NAME + "/" + GET_FILE_TYPES, {
        url: FILE_TYPES_URL,
        filters: {
          exam: true,
        },
      });
    },
    addInstructorName(event) {
      this.instructorNames.push(event);
      this.form.classroom_education.instructor_name = event;
    },
    addEducationPlace(event) {
      this.educationPlaces.push(event);
      this.form.classroom_education.education_place = event;
    },
    addTag(newTag, id = null) {
      const tag = {
        name: newTag,
        id:
            id ??
            "custom_" +
            newTag.substring(0, 2) +
            Math.floor(Math.random() * 10000000),
      };
      this.hashtags_options.push(tag);
      this.hashtags.push(tag);
    },
    processFile(event) {
      if (!event.target.files[0]) return false;
      this.form.cover_photo = event.target.files[0];
      let blob = URL.createObjectURL(this.form.cover_photo);
      let imageHolder = $(".logoarea");
      imageHolder.attr("src", blob);
    },
    handleAiCoverImageSelected({ file, previewUrl }) {
      this.form.cover_photo = file;
      $(".logoarea").first().attr("src", previewUrl);
    },
    inputClick() {
      $("#logo").click();
    },
    dropped(event) {
      let file = event.target.files[0];
      if (!file) return false;

      if (!this.compareTypeCompatibality(file, this.acceptable_file_type)) {
        $("#uploadFile").val("");
        this.errorMessages.push(this.$t("general.invalid_file_type"));
        return false;
      }
      if (!this.validateFileSize(file)) {
        this.form.files = [];
        this.interactiveVideoURL = "";
        this.videoDocInfo = "";
        let preview = document.getElementById("preview");
        if (preview) preview.innerHTML = "";
        return false;
      }
      this.form.files = event.target.files[0];
      let fileName = URL.createObjectURL(event.target.files[0]);
      let preview = document.getElementById("preview");


      this.interactiveVideoURL = fileName;
      this.videoDocInfo = this.docInfo(file);

      let previewImg = false;
      if (this.acceptable_file_type.includes("pdf"))
        previewImg = document.createElement("embed");
      if (this.acceptable_file_type.includes("image"))
        previewImg = document.createElement("img");
      if (
          file.type.includes("audio") &&
          this.acceptable_file_type.includes("audio")
      )
        previewImg = document.createElement("audio");
      if (file.type.includes("video") && this.acceptable_file_type.includes("video")) {
        previewImg = document.createElement("video");
        // en dış katmanda kontrol , interactive için store verisi verisi varsa temizle
        this.$store.dispatch('clearMarkers')
      }
      if (previewImg && previewImg.controls != undefined)
        previewImg.controls = true;
      let docInfo = document.createElement("p");
      docInfo.innerHTML = this.docInfo(file);
      if (previewImg) previewImg.setAttribute("src", fileName);

      // Görsel için max-height ayarla
      if (previewImg && previewImg.tagName.toUpperCase() == "IMG") {
        previewImg.style.maxHeight = "300px";
        previewImg.style.objectFit = "cover";
        previewImg.style.width = "auto";
      }

      if (previewImg && previewImg.tagName.toUpperCase() == "EMBED") {
        previewImg.style.width = "100%";
        previewImg.style.minHeight = "300px";
        previewImg.setAttribute("type", file.type);
      }

      preview.innerHTML = "";
      preview.appendChild(docInfo);
      if (previewImg) preview.appendChild(previewImg);

      this.drop(event);
    },
    droppedMission(event) {
      let file = event.target.files[0];
      if (!file) return false;
      if (!this.validateFileSize(file)) {
        this.form.mission.mission_file = "";
        let preview = document.getElementById("previewMission");
        if (preview) preview.innerHTML = "";
        return false;
      }

      this.form.mission_file = event.target.files[0];
      let fileName = URL.createObjectURL(event.target.files[0]);
      let preview = document.getElementById("previewMission");
      let previewImg = false;
      if (this.acceptable_file_type.includes("pdf"))
        previewImg = document.createElement("embed");
      if (this.acceptable_file_type.includes("image"))
        previewImg = document.createElement("img");
      if (
          file.type.includes("audio") &&
          this.acceptable_file_type.includes("audio")
      )
        previewImg = document.createElement("audio");
      if (
          file.type.includes("video") &&
          this.acceptable_file_type.includes("video")
      )
        previewImg = document.createElement("video");
      if (previewImg && previewImg.controls != undefined)
        previewImg.controls = true;
      let docInfo = document.createElement("p");
      docInfo.innerHTML = this.docInfo(file);
      if (previewImg) previewImg.setAttribute("src", fileName);

      // Görsel için max-height ayarla
      if (previewImg && previewImg.tagName.toUpperCase() == "IMG") {
        previewImg.style.maxHeight = "300px";
        previewImg.style.objectFit = "cover";
        previewImg.style.width = "auto";
      }

      if (previewImg && previewImg.tagName.toUpperCase() == "EMBED") {
        previewImg.style.width = "100%";
        previewImg.style.minHeight = "300px";
        previewImg.setAttribute("type", file.type);
      }
      preview.innerHTML = "";
      preview.appendChild(docInfo);
      if (previewImg) preview.appendChild(previewImg);
      this.drop(event);
    },
    compareTypeCompatibality(file, acceptableType) {
      return (
          acceptableType.includes(file.type) ||
          acceptableType.includes(file.name.split(".").pop()) ||
          (acceptableType.split("/")[0] == file.type.split("/")[0] &&
              file.type.split("/")[0].toLowerCase() != "application")
      );
    },
    drag(event) {
      if (event.target.parentNode) event.target.parentNode.className = "draging dragBox";
    },
    drop(event) {
      if (event.target.parentNode) event.target.parentNode.className = "dragBox";
    },
    docInfo(file) {
      let file_complete_name = file.name;
      let file_name_split = file_complete_name.split(".");
      let file_extension = file_name_split.pop().toLowerCase();
      let file_name = file_name_split.join(".");
      let file_size = this.bytesToSize(file.size);
      return (
          '<div class="file-info"><div>' + this.$t("general.format") + ': <span>' +
          file_extension.toUpperCase() +
          "</span></div><div>" + this.$t("general.document_name") + ": <span>" +
          file_name +
          "</span></div><div>" + this.$t("general.size") + ": <span>" +
          file_size +
          "</span></div></div>"
      );
    },
    bytesToSize(bytes) {
      let sizes = ["Bytes", "KB", "MB", "GB", "TB"];
      if (bytes == 0) return "0 Byte";
      let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
      return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
    },
    resetMessages() {
      this.successMessage = null;
      this.errorMessages = [];
    },
    isValidFields(fields) {
      let self = this;
      let form = self.form;
      self.resetMessages();

      // Edit modunda: Sadece yeni dosya yüklendiyse kontrol et
      let files = null;
      if (form.files instanceof File) files = form.files;

      if (fields === "ALL" || fields === 0) {
        if (form.title.length === 0) {
          return self.showFieldsFailedError(
              0,
              self
                  .$t("validation.required_field")
                  .replace(":NAME", self.$t("collectionDetail.content_name"))
          );
        }

        if (form.duration < 1) {
          return self.showFieldsFailedError(
              0,
              self.$t("validation.required_field").replace(":NAME", self.$t("general.duration"))
          );
        }
        if (!form.content_category_id) {
          return self.showFieldsFailedError(
              0,
              self.$t("validation.required_field").replace(":NAME", self.$t("faq.category"))
          );
        }
        // Cover photo sadece ekleme modunda zorunlu, güncelleme modunda isteğe bağlı
        if (!this.isEditMode && form.cover_photo == null) {
          return self.showFieldsFailedError(
              0,
              self.$t("validation.required_field").replace(":NAME", self.$t("general.cover_image"))
          );
        }
      }
      if (fields === "ALL" || fields === 1) {
        if (
            form.use_content_point === false &&
            (form.point > 100 || form.point < 1)
        ) {
          return self.showFieldsFailedError(
              1,
              self
                  .$t("content.invalid.score_between_1_100")
                  .replace(":NAME", self.$t("general.content_score"))
          );
        }
        if (!form.file_category_id) {
          return self.showFieldsFailedError(
              1,
              self.$t("validation.required_field").replace(":NAME", self.$t("general.content_type"))
          );
        }
        if (
            this.acceptable_file_type === "url" &&
            (form.url == null || !this.validateURL(form.url))
        ) {
          return self.showFieldsFailedError(
              1,
              self
                  .$t("validation.required_field")
                  .replace(":NAME", self.$t(self.selected_content_type.key))
          );
        }
        if (
            self.acceptable_file_type !== "form" &&
            self.acceptable_file_type !== "url" &&
            self.acceptable_file_type !== "id" &&
            files != null &&
            (files?.length === 0 ||
                !self.compareTypeCompatibality(files, self.acceptable_file_type))
        ) {
          return self.showFieldsFailedError(
              1,
              self.$t("validation.required_field").replace(":NAME", self.$t("general.link_address"))
          );
        }

        if (this.acceptable_file_type === "id" && form.url == null) {
          return self.showFieldsFailedError(
              1,
              self
                  .$t("validation.required_field")
                  .replace(":NAME", self.$t("general.anzera_education_id"))
          );
        }
        // Sınıf içi eğitim
        if (
            this.acceptable_file_type === "form" &&
            this.selected_content_type.key === "documents.classroom_education"
        ) {
          if (!form.classroom_education.instructor_name) {
            return self.showFieldsFailedError(
                1,
                self
                    .$t("validation.required_field")
                    .replace(":NAME", self.$t("general.instructor_name"))
            );
          }

          if (!form.classroom_education.education_place) {
            return self.showFieldsFailedError(
                1,
                self
                    .$t("validation.required_field")
                    .replace(":NAME", self.$t("general.place_of_education"))
            );
          }
        }
        if (
            this.selected_content_type.key === "documents.information_content" &&
            (this.form.information_content === "" ||
                !this.form.information_content)
        ) {
          return self.showFieldsFailedError(
              1,
              self
                  .$t("validation.required_field")
                  .replace(":NAME", self.$t("general.information_content"))
          );
        } else if (
            this.selected_content_type.key === "documents.check_list_item"
        ) {
          if (
              form.content_check_list_item_description === "" ||
              !form.content_check_list_item_description
          ) {
            return self.showFieldsFailedError(
                1,
                self
                    .$t("validation.required_field")
                    .replace(":NAME", self.$t("general.explanatory_text"))
            );
          }
          let flag = true;
          this.form.content_check_list_items.every((data) => {
            if (!data.name || data.name === "") {
              flag = false;
              return false;
            } else {
              return true;
            }
          });
          if (!flag) {
            return self.showFieldsFailedError(
                1,
                self
                    .$t("validation.required_field")
                    .replace(":NAME", self.$t("general.checklist_items"))
            );
          }
        } else if (this.selected_content_type.key === "documents.mission") {
          if (form.mission.mission_description === "" || !form.mission.mission_description) {
            return self.showFieldsFailedError(
                1,
                self
                    .$t("validation.required_field")
                    .replace(":NAME", self.$t("general.task_description"))
            );
          }
        }
      }

      return true;
    },
    showFieldsFailedError(index, message) {
      this.errorMessages.push(message);
      this.scrollToTop();
      this.switcherChange(index);
      return false;
    },
    validateAndSwitch(index) {
      if (this.isValidFields(index - 1)) this.switcherChange(index);
    },
    switcherChange(index) {
      UIkit.switcher($("#uk-switcher-tab")[0]).show(index);
    },
    scrollToTop() {
      window.scroll({
        top: 0,
        behavior: "smooth",
      });
    },
    durationCalculate() {
      this.form.duration = 0;
      this.minutes > 59 ? (this.minutes = 59) : this.minutes;
      let hour = this.hour ? parseInt(this.hour) * 60 : 0;
      let minutes = this.minutes ? parseInt(this.minutes) : 0;
      this.form.duration = hour + minutes;
    },
    addCheckListItem() {
      let self = this;
      self.form.content_check_list_items.push({
        name: null,
        is_mandatory: false,
      });
    },
    handleMissionFileUpload(file) {
      if (!this.validateFileSize(file)) {
        this.form.mission.mission_file = "";
        return false;
      }
      this.form.mission.mission_file = file;
    },
    handleGeneralFileUpload(file) {
      // Standard dosya tiplerini (scorm, pdf, word, görsel, ses) handle et
      if (!this.validateFileSize(file)) {
        this.form.files = [];
        return false;
      }
      this.dropped({ target: { files: [file] } });
    },
    handleVideoFileUpload(file) {
      // Video dosyasını handle et
      if (!this.validateFileSize(file)) {
        this.form.files = [];
        this.interactiveVideoURL = "";
        this.videoDocInfo = "";
        return false;
      }
      this.form.files = file;
      let fileName = URL.createObjectURL(file);

      this.interactiveVideoURL = fileName;
      this.videoDocInfo = this.docInfo(file);

      // Interactive video için store'u temizle
      this.$store.dispatch('clearMarkers');
    },
    handleUploadError(message) {
      this.errorMessages.push(message);
      this.scrollToTop();
    },
    setControlListItems() {
      this.form.content_check_list_items = [
        { name: null, is_mandatory: false },
      ];
    },
    getItem() {
      if (!this.isEditMode) return;

      store.dispatch(CONTENT_MODULE_NAME + "/" + GET_ITEM, {
        url: BASE_URL + "/" + this.$route.params.id,
      }).then((response) => {
        if (response) {
          // Vue'nun computed property'leri güncellemesi için bekle
          this.$nextTick(() => {
            this.populateForm(response);
          });

          // Webinar türleri yükle
          if (response.file_category_id === 18) {
            axios.get(`/api/webinar-integrations`, {
              headers: this.apiHeaders,
            }).then((integrationResponse) => {
              this.webinar_types = [];
              integrationResponse.data.forEach((data) => {
                this.webinar_types.push({
                  name: data.integration.name,
                  id: data.id,
                  key: data.integration.key_name
                });
              });

              if (response.webinar_integration_id) {
                const selectedType = this.webinar_types.find(
                    type => type.id === response.webinar_integration_id
                );
                if (selectedType) {
                  this.webinar_integrationType = selectedType;
                  this.selectedWebinarType = selectedType;
                  this.form.webinar.integration_id = selectedType.id;
                }
              }
            });
          }

          // Sınıf içi eğitim hashtags
          if (response.file_category_id === 14) {
            axios.get(`/api/content-classroom-education-hashtags`, {
              headers: this.apiHeaders,
            }).then((hashtagResponse) => {
              this.instructorNames = hashtagResponse.data.instructor_name;
              this.educationPlaces = hashtagResponse.data.education_place;
            });
          }
        }
      });
    },
    populateForm(item) {
      // Form verilerini doldur
      this.form.title = item.title || "";
      this.title = item.title || this.$t("general.heading");
      this.form.description = item.description || "";
      this.form.point = item.point || 100;

      // Atama yapılmış mı kontrolü (içerik atanmışsa skor ve tür değiştirilemeyecek)
      this.is_assigned_content = item.assignments_count > 0;

      // Duration saat ve dakikaya çevir
      const totalMinutes = item.duration || 0;
      this.hour = Math.floor(totalMinutes / 60).toString();
      this.minutes = (totalMinutes % 60).toString();
      this.form.duration = totalMinutes;

      // Category ve file_category
      this.form.content_category_id = this.formattedContentCategories.find(
          cat => cat.id === item.content_category_id
      );
      this.form.file_category_id = this.formattedFileTypes.find(
          type => type.id === item.file_category_id
      );

      // Seçili content type'ı set et
      if (this.form.file_category_id) {
        this.selected_content_type = this.form.file_category_id;
        this.acceptable_file_type = this.form.file_category_id.accept;
        this.file_type_selected = this.$t(this.form.file_category_id.key);
      }

      // Diğer alanlar
      this.form.url = item.url;
      this.form.use_content_point = item.use_content_point || false;
      this.form.certificate_id = this.certificate_items?.find(cert => cert.id === item.certificate_id);

      this.form.instructors = Array.isArray(item.instructors)
          ? item.instructors.map(normalizeInstructor)
          : [];
      const knownInstructorIds = new Set(
          this.instructorOptions.map((instructor) => instructor.id)
      );
      this.form.instructors.forEach((instructor) => {
        if (!knownInstructorIds.has(instructor.id)) {
          this.instructorOptions.push(instructor);
        }
      });

      // Sınıf içi eğitim bilgileri
      if (item.instructor_name) this.form.classroom_education.instructor_name = item.instructor_name;
      if (item.accommodation_cost) this.form.classroom_education.accommodation_cost = item.accommodation_cost;
      if (item.education_place) this.form.classroom_education.education_place = item.education_place;
      if (item.education_cost) this.form.classroom_education.education_cost = item.education_cost;
      if (item.transportation_cost) this.form.classroom_education.transportation_cost = item.transportation_cost;
      if (item.education_place_cost) this.form.classroom_education.education_place_cost = item.education_place_cost;
      if (item.capacity) this.form.classroom_education.capacity = item.capacity;

      // Webinar bilgileri
      if (item.webinar_starts_at) this.form.webinar.starts_at = item.webinar_starts_at;
      if (item.webinar_password) this.form.webinar.password = item.webinar_password;
      if (item.webinar_is_auto_recording_enabled) this.form.webinar.is_auto_recording_enabled = item.webinar_is_auto_recording_enabled;
      if (item.webinar_integration_id) this.form.webinar.integration_id = item.webinar_integration_id;
      // Backend'den hem item.webinar_instructor_name hem de item.webinar.instructor_name olarak gelebiliyor
      this.form.webinar.webinar_instructor_name = item.webinar_instructor_name || item.webinar?.instructor_name || null;

      // Kontrol listesi
      if (item.content_check_list_items && item.content_check_list_items.length > 0) {
        this.form.content_check_list_items = item.content_check_list_items;
        if (item.content_check_list_items[0]?.description) {
          this.form.content_check_list_item_description = item.content_check_list_items[0].description;
        }
      }

      // Görev bilgileri
      if (item.content_mission) {
        this.form.mission.mission_description = item.content_mission.mission_description || "";
        this.form.mission.answer_type = item.content_mission.answer_type || "file";
        this.form.mission.completion_rule = item.content_mission.completion_rule || "answered";
        this.form.mission.should_upload_mission_file = item.content_mission.should_upload_mission_file || false;
        this.form.mission.accepted_right_answer = item.content_mission.accepted_right_answer || "";
        this.form.mission.mission_file = item.content_mission.mission_file || "";
      }

      // Bilgi içeriği
      if (item.information_content) this.form.information_content = item.information_content;

      // Hashtags
      if (item.hashtags && item.hashtags.length > 0) {
        item.hashtags.forEach((hashtag) => {
          this.addTag(hashtag.name, hashtag.id);
        });
        this.handleHashtagsSelected();
      }

      // Competencies
      if (item.competencies) this.form.selectedCompetencies = item.competencies;

      // Share content ve share experience
      this.form.share_content = item.share_content || 0;
      this.form.share_experience = item.share_experience || 0;

      // Content share display için (yorum satırındaki HTML için)
      if (item.share_content == 1) {
        this.content_share = "Açık";
      } else {
        this.content_share = "Kapalı";
      }

      // Cover photo
      if (item.cover_photo_link) {
        $(".logoarea").attr("src", item.cover_photo_link);
      }

      // Powerpoint özel ayarlar - önce scorm kontrolü yapılır, scorm ise süreye bakmaya gerek yok
      if (item.is_powerpoint_scorm_file) {
        this.form.powerpoint.is_scorm_file = true;
        this.form.powerpoint.is_completion_timeout = false;
      } else if (item.completion_timeout) {
        this.form.powerpoint.is_completion_timeout = true;
        this.form.powerpoint.completion_timeout = item.completion_timeout;
      }

      // Video özellikleri
      if (item.video_can_be_fast_forwarded) this.video_can_be_fast_forwarded = item.video_can_be_fast_forwarded;
      if (item.video_is_completed_it_can_be_fast_forwarded) {
        this.video_is_completed_it_can_be_fast_forwarded = item.video_is_completed_it_can_be_fast_forwarded;
      }

      // Video dosyası ve interaction bilgisi
      if (item.file?.file_link) {
        this.interactiveVideoURL = item.file.file_link;
      }
      if (item.is_video_interaction && item.exam_id) {
        this.isInteractiveVideoActive = true;
        this.getVideoInteractionInfo(item.exam_id);
      }
    },
    async getVideoInteractionInfo(examId) {
      try {
        const response = await axios.get(process.env.VUE_APP_BACKEND_APP_URL + "/api/exam/" + examId);

        if (response.data && response.data.questions) {
          // Gelen questions verisini marker formatına dönüştür
          const markers = response.data.questions.map(question => {
            // time_in_video string'ini saniyeye çevir, marker konumları için gerekli (HH:MM:SS -> seconds)
            const timeInVideo = this.convertTimeToSeconds(question.time_in_video);

            return {
              id: question.id,
              exam_id: response.data.id, // Exam ID'yi ekle
              text: question.text,
              type: question.question_type_id,
              time_in_video: question.time_in_video,
              time: timeInVideo,
              back_time: question.back_time,
              options: question.options.map(option => ({
                id: option.id, // Option ID'yi ekle
                name: option.text,
                is_correct: option.is_correct === 1
              })),
              correct_feedback: question.correct_feedback || '',
              incorrect_feedback: question.incorrect_feedback || '',
              is_feedback: question.is_feedback
            };
          });

          // Store'a marker'ları ekle
          await this.$store.dispatch('setMarkers', markers);
        }
      } catch (error) {
        console.error("Error fetching video interaction info:", error);
      }
    },
    // HH:MM:SS formatındaki string'i saniyeye çevir
    convertTimeToSeconds(timeString) {
      if (!timeString) return 0;

      const parts = timeString.split(':');
      if (parts.length === 3) {
        const hours = parseInt(parts[0]) || 0;
        const minutes = parseInt(parts[1]) || 0;
        const seconds = parseInt(parts[2]) || 0;
        return hours * 3600 + minutes * 60 + seconds;
      }
      return 0;
    },
  },
  mounted() {
    this.getCertificates();
    this.getInstructorOptions();
    this.getContentCategories();
    this.getFileCategories();
    this.setHashtags();

    if (this.isEditMode) {
      // Edit mode - veriyi yükle
      this.getItem();
    } else {
      // Add mode - boş kontrol listesi ekle
      this.setControlListItems();
    }
  },
  watch: {
    '$route'(to, from) {
      // Route değiştiğinde sayfayı tamamen yenile -- note : kod değişiminde sayfa tteiklenmiyor hemen , bu hata giderilirse , bu kod kalkabilir
      if (to.path !== from.path) {
        window.location.reload();
      }
    },
    // Kategoriler yüklendiğinde, edit mode ise ve henüz form dolmamışsa populate et
    formattedContentCategories(value) {
      if (value && value.length > 0 && this.isEditMode && this.item && !this.form.content_category_id) {
        this.$nextTick(() => {
          this.form.content_category_id = value.find(cat => cat.id === this.item.content_category_id);
        });
      }
    },
    // File type'lar yüklendiğinde, edit mode ise ve henüz form dolmamışsa populate et
    formattedFileTypes(value) {
      if (value && value.length > 0 && this.isEditMode && this.item && !this.form.file_category_id) {
        this.$nextTick(() => {
          const foundFileType = value.find(type => type.id === this.item.file_category_id);
          if (foundFileType) {
            this.form.file_category_id = foundFileType;
            this.selected_content_type = foundFileType;
            this.acceptable_file_type = foundFileType.accept;
            this.file_type_selected = this.$t(foundFileType.key);
          }
        });
      }
    },
    minutes: function (value) {
      if (value) {
        this.durationCalculate();
      }
    },
    hour: function (value) {
      if (value) {
        this.durationCalculate();
      }
    },
    "form.file_category_id": function (value) {
      if (value && value.id !== 1) {
        this.form.use_content_point = false;
      }
    },
    "form.use_content_point": function (value) {
      if (value) {
        this.form.point = 0;
      } else {
        this.form.point = 100;
      }
    },
    "form.powerpoint.is_scorm_file": function () {
      if (!(this.form.files instanceof File)) {
        this.fileSizeError = "";
        this.fileSizeErrorSize = null;
        return;
      }

      if (!this.validateFileSize(this.form.files)) {
        this.form.files = [];
        $("#preview").html("");
      }
    },
    "$i18n.locale": function () {
      if (!this.fileSizeErrorSize) return;
      this.fileSizeError = this.buildFileSizeErrorMessage({ size: this.fileSizeErrorSize });
    },
    hashtags() {
      this.handleHashtagsSelected();
    },
    successMessage: function (val) {
      this.debouncedResetValues();
    },
    errorMessages: function (val) {
      this.debouncedResetValues();
    },
  },
  created: function () {
    this.debouncedResetValues = _.debounce(this.resetMessages, 2500);
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
input[type="button"],
input[type="submit"],
span.btn,
.btn {
  display: inline-block;
}

.content-instructor-option {
  display: flex;
  align-items: center;
  gap: 10px;
}

.content-instructor-option img {
  width: 34px;
  height: 34px;
  flex-shrink: 0;
  border-radius: 50%;
  background: #eef2f6;
  object-fit: cover;
  object-position: center top;
}

.content-instructor-option span {
  display: flex;
  min-width: 0;
  flex-direction: column;
}

.content-instructor-option strong,
.content-instructor-option small {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.content-instructor-option small {
  color: #8491a3;
  font-size: 11px;
}

.content-instructor-tag {
  display: inline-flex;
  align-items: center;
}

.dragBox input[type="file"] {
  position: absolute;
  height: 100%;
  width: 100%;
  opacity: 0;
  top: 0;
  left: 0;
}

.dragBox {
  width: auto;
  padding: 0 10px;
  height: 100px;
  margin: 0 auto;
  position: relative;
  text-align: center;
  font-weight: bold;
  line-height: 95px;
  color: #999;
  border: 2px dashed #ccc;
  display: inline-block;
  -webkit-transition: -webkit-transform 0.3s;
  transition: -webkit-transform 0.3s;
  transition: transform 0.3s, -webkit-transform 0.3s;
}

.uploadOuter strong {
  padding: 0 10px;
}

.uploadOuter {
  text-align: center;
  padding: 20px;
}

.video-type-selection {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}

.standart-video-area .artplayer-app {
  max-height: 500px;
}

.file-info {
  background: #f5f5f5;
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 15px;
  display: flex;
  gap: 20px;
  align-items: center;
  flex-wrap: wrap;
}

.file-info div {
  margin-bottom: 0;
}

.file-info span {
  font-weight: 600;
  color: #333;
}

.file-info a {
  color: #007bff;
  text-decoration: none;
}

.file-info a:hover {
  text-decoration: underline;
}

/* Preview alanındaki görseller için */
#preview img,
#previewMission img {
  max-height: 300px;
  object-fit: cover;
  width: auto;
}

/* Atanmış içerik uyarısı */
.alert-warning {
  background-color: #fff3cd;
  border: 1px solid #ffc107;
  border-radius: 6px;
  padding: 12px 15px;
  color: #856404;
  display: flex;
  align-items: center;
}

.alert-warning i {
  font-size: 18px;
  color: #ffc107;
}

/* SCORM güncellenemez bilgi uyarısı */
.alert-info {
  background-color: #d1ecf1;
  border: 1px solid #17a2b8;
  border-radius: 6px;
  padding: 12px 15px;
  color: #0c5460;
  display: flex;
  align-items: center;
}

.alert-info i {
  font-size: 18px;
  color: #17a2b8;
}
</style>

<style>
.artplayer-app {
  height: 500px !important;
}

.multiselect__tag {
  color: white;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  background-color: #3e416d;
}

.multiselect__tag-icon {
  background-color: transparent;
  line-height: 2.2;
}

.multiselect__tag-icon:after {
  color: #fff;
}

.multiselect__tag-icon:hover {
  background-color: rgba(0, 0, 0, 0.1);
}

.multiselect__input {
  border: unset !important;
}

.multiselect__tags .multiselect__input {
  border: unset !important;
}
</style>
